import UserService from '../../shared/user-service';
import { isAllowed } from '../../shared/permissions/RestrictTo';
import { PERMISSION_REAPPLY_TO_DRIVE } from '../../shared/permissions/permissions';

export default {
  isAuthorized: () => {
    const userProfile = UserService.getUserProfile();

    return userProfile && userProfile.isInVanpool && !userProfile.isDriver || isAllowed([PERMISSION_REAPPLY_TO_DRIVE]);
  },
  byPass: () => {
    const userProfile = UserService.getUserProfile();
    return userProfile && userProfile.isInVanpool && !userProfile.isDriver && userProfile.isPendingDriver && !userProfile.isPendingCoordinator;
  }
};
